import { Routes } from '@angular/router';
import { ShellComponent } from './core/shell.component';
import { AuthGuard } from './core/guards/auth.guard';
import { oktaAuthGuard, redirectIfAuthenticatedGuard } from './core/guards/okta-auth.guard';

export const routes: Routes = [
  {
    path: '',
    component: ShellComponent,
    children: [
      {
        path: 'auth/login',
        canActivate: [redirectIfAuthenticatedGuard],
        loadComponent: () =>
          import('./features/auth/login/login.component').then((m) => m.LoginComponent),
      },
      {
        path: 'auth/login/callback',
        loadComponent: () =>
          import('./features/auth/login/login-callback.component').then(
            (m) => m.LoginCallbackComponent,
          ),
      },
      {
        path: 'data-collection',
        canActivate: [AuthGuard],
        loadComponent: () =>
          import('./features/data-collection/data-collection-dashboard.component').then(
            (m) => m.DataCollectionDashboardComponent,
          ),
      },
      {
        path: 'bidding',
        canActivate: [oktaAuthGuard],
        children: [
          {
            path: '',
            loadComponent: () =>
              import('./features/bidding/portal/bidding-portal.component').then(
                (m) => m.BiddingPortalComponent,
              ),
          },
          {
            path: 'live/:id',
            loadComponent: () =>
              import('./features/bidding/live/live-bid.component').then((m) => m.LiveBidComponent),
          },
        ],
      },
      { path: '', redirectTo: 'bidding', pathMatch: 'full' },
      { path: '**', redirectTo: 'bidding' },
    ],
  },
];
